<template>
  <div
    :class="{
      'field-text-domain': true,
      [`field-text-domain_background-${backgroundColor}`]: true,
    }"
    v-text="domainText"
  />
</template>

<script lang="ts" setup>
defineProps<{
  domainText: string
  backgroundColor: 'white' | 'shade'
}>()
</script>

<style lang="scss" scoped>
@use '@/styles/fields/const' as fieldConst;

.field-text-domain {
  font-size: $font-size-root;
  font-weight: $semi-bold-font;
  margin-right: -7px;
  border: 2px solid $shade;
  border-radius: 0 $border-radius $border-radius 0;
  height: fieldConst.$textInputHeight;
  line-height: 36px;
  padding: 0 10px 0 14px;
  color: $neutral;

  &_background-white {
    background: $white;
  }
  &_background-shade {
    background: $shade;
  }
}
</style>
